import { useRef, useState } from "react";
import { ScanLine, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const TRAY_KEY = "orse_active_tray";
export const loadTray = () => { try { return localStorage.getItem(TRAY_KEY) || ""; } catch { return ""; } };
export const saveTray = (v) => { try { localStorage.setItem(TRAY_KEY, v || ""); } catch {} };

// Tray (tabla) input: type manually OR scan a tray barcode with the camera.
export function TrayInput({ value, onChange, className, testid }) {
  const [scanOpen, setScanOpen] = useState(false);
  const videoRef = useRef();
  const controlsRef = useRef(null);

  const startScan = async () => {
    setScanOpen(true);
    try {
      const { BrowserMultiFormatReader } = await import("@zxing/browser");
      const reader = new BrowserMultiFormatReader();
      const controls = await reader.decodeFromVideoDevice(undefined, videoRef.current, (result) => {
        if (result) { onChange(result.getText()); toast.success("Tabla barkodu okundu"); stopScan(); }
      });
      controlsRef.current = controls;
    } catch {
      toast.error("Kamera açılamadı. Tablayı elle yazabilir veya el okuyucu ile taratabilirsiniz.");
      setScanOpen(false);
    }
  };
  const stopScan = () => { try { controlsRef.current?.stop(); } catch {} controlsRef.current = null; setScanOpen(false); };

  return (
    <div className="flex gap-2">
      <Input
        data-testid={testid}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Örn. TABLA-01"
        className={className}
      />
      <button type="button" data-testid={testid ? `${testid}-scan` : undefined} onClick={startScan}
        className="shrink-0 px-3 rounded-md border border-border text-gold hover:border-gold transition-colors flex items-center gap-1 text-sm">
        <ScanLine size={16} /> Okut
      </button>
      {scanOpen && (
        <div className="fixed inset-0 z-[60] bg-black/90 flex flex-col items-center justify-center p-4" data-testid="tray-scan-modal">
          <video ref={videoRef} className="w-full max-w-md rounded-lg" />
          <p className="text-white text-sm mt-3">Tabla barkodunu kameraya gösterin</p>
          <button onClick={stopScan} className="mt-4 px-5 h-10 bg-white text-black rounded-md flex items-center gap-2"><X size={16} /> Kapat</button>
        </div>
      )}
    </div>
  );
}
